// branding.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { AuthTenantService } from '../authentication/auth-tenant.service';
import { AuthenticationService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class BrandingService {
  constructor(
    private title: Title,
    private tenantService: AuthenticationService,
    private authTenantService: AuthTenantService
  ) { }

  loadBranding(): Promise<void> {
    return new Promise((resolve) => {
      this.tenantService.getTenantInfo()
        .subscribe({
          next: (branding) => {
            this.authTenantService.setTenantFromApi(branding);
            // Example: branding.appName = "Falconpad - Texakey Technologies"
            this.title.setTitle(branding.name);
            this.setFavicon(branding.logoUrl);
            const root = document.documentElement;
            const primary = branding.primaryColor.startsWith('#')
              ? branding.primaryColor
              : `#${branding.primaryColor}`;

            const secondary = branding.secondaryColor.startsWith('#')
              ? branding.secondaryColor
              : `#${branding.secondaryColor}`;

            root.style.setProperty('--daxaColor', primary);
            root.style.setProperty('--primaryColor', secondary);
            resolve();
          },
          error: () => {
            this.title.setTitle('Falconpad'); // fallback
            resolve();
          }
        });
    });
  }
  private setFavicon(url: string): void {
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.type = 'image/x-icon'; // change if using png
    link.href = url;
  }

}
